import React from "react";
import { Label } from "@/components/ui/label";

export const STAGES = [
  { key: "applied", label: "Applied" },
  { key: "shortlisted", label: "Shortlisted" },
  { key: "scheduled", label: "Scheduled" },
  { key: "pitched", label: "Pitched" },
  { key: "published", label: "Published" },
  { key: "rejected", label: "Rejected" },
];

export const OUTCOMES = [
  { v: "invested", label: "Invested €20K", cls: "bg-success text-black" },
  { v: "passed", label: "Passed", cls: "bg-danger text-white" },
  { v: "follow_up", label: "Follow-up", cls: "bg-warn text-black" },
];

export const TA_STAGES = [
  { key: "received", label: "Received" },
  { key: "connected", label: "Connected" },
  { key: "agreed", label: "Agreed" },
];

export const LI_TAG_OPTIONS = [
  { v: "behind_the_scenes", label: "Behind the scenes" },
  { v: "episode_teaser", label: "Episode teaser" },
  { v: "deal_breakdown", label: "Deal breakdown" },
  { v: "announcement", label: "Announcement" },
  { v: "other", label: "Other" },
];

export const KIND_LABEL = { tag_along: "Tag along", solo_invest: "Invest anyway" };

export const EMPTY_EPISODE_FORM = {
  startup_name: "", one_liner: "", long_description: "", website: "", country: "", year_incorporation: new Date().getFullYear(),
  industry: "", outcome: "invested", linkedin_video_url: "", cover_image_path: "", host_notes: "", application_id: null, published: true, tag_along_total: 0, tag_along_enabled: true, solo_invest_enabled: false,
};

export const EMPTY_LI_FORM = {
  post_url: "",
  embed_url: "",
  cover_image_path: "",
  caption: "",
  tag: "other",
  published_at: new Date().toISOString().slice(0, 10),
  pinned: false,
  display_mode: "card",
  sort_order: 0,
};

export const inputCls = "bg-black border-white/10 rounded-none text-white focus-visible:ring-lime";

export function StageBadge({ stage }) {
  const cls = {
    applied: "bg-white/10 text-white",
    shortlisted: "bg-lime text-black",
    scheduled: "bg-warn text-black",
    pitched: "bg-white text-black",
    published: "bg-success text-black",
    rejected: "bg-danger text-white",
  }[stage] || "bg-white/10 text-white";
  return <span className={`px-2 py-1 text-[10px] font-mono uppercase tracking-widest font-bold ${cls}`}>{stage}</span>;
}

export function OutcomeBadge({ o }) {
  const cfg = OUTCOMES.find((x) => x.v === o);
  if (!cfg) return null;
  return <span className={`px-2 py-1 text-[10px] font-mono uppercase tracking-widest font-bold ${cfg.cls}`}>{cfg.label}</span>;
}

export function Row({ label, value }) {
  return (
    <div>
      <div className="text-white/40 font-mono text-[10px] uppercase tracking-widest">{label}</div>
      <div className="text-white mt-1">{value || "—"}</div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs font-mono uppercase tracking-widest text-white/50">{label}</Label>
      <div className="mt-2">{children}</div>
    </div>
  );
}
